import { useStores } from 'utility/hooks/useStores';
import { toJS } from 'mobx';
import { FlightsJourneyCriteriaInput, FlightsQueryState } from '__generated__/api';

import { InterstitialAdInputs } from '@shared-ui/retail-sponsored-content-interstitial-ad';

export const useInterstitialAdInputs = (): InterstitialAdInputs => {
  const { searchCriteriaStore } = useStores();

  const { journeyCriteria } = searchCriteriaStore.searchCriteria;

  return {
    journeyCriteria: toJS(journeyCriteria) as FlightsJourneyCriteriaInput[],
    queryState: FlightsQueryState.LOADING
  };
};
